<template>
  <div class="h5-container">
    <van-nav-bar
        class="top-bar"
        title="售后进度查询"
        left-text="返回"
        left-arrow
        @click-left="onClickLeft"
    ></van-nav-bar>
    <div class="container-item">
      <van-card shadow="never" class="search-card">
        <template #desc>
          <van-field
              readonly
              clickable
              name="picker"
              :value="number"
              label="球杆编码"
              placeholder="点击选择球杆编码"
              @click="showPicker = true"
              class="search-input"
          />
          <van-popup v-model="showPicker" position="bottom">
            <van-picker
                show-toolbar
                :columns="selectOptions"
                @confirm="onConfirm"
                @cancel="showPicker = false"
            />
          </van-popup>
        </template>
      </van-card>

      <van-button v-if="number" class="search-btn" block @click="getProgress">查询</van-button>

      <van-steps v-if="stepList.length>0" direction="vertical" :active="0" class="step-content">
        <van-step v-for="item in stepList" :key="item.id">
          <h3>{{item.code}}</h3>
          <p>{{item.send_time}}</p>
        </van-step>
      </van-steps>
    </div>
  </div>
</template>

<script>
import '@/assets/css/mobileGlobal.scss';
import {productByUser, progress} from "@/api/sales";
import {Dialog} from "vant";

export default {
  data(){
    return {
      number: '',
      selectOptions: [],
      showPicker: false,
      stepList: [],
    }
  },
  created() {
    this.selectProductByUser();
  },
  methods: {
    //顶部标题栏返回事件
    onClickLeft() {
      this.$router.push('/app_home');
    },
    //序列号确认事件
    onConfirm(value) {
      this.number = value;
      this.showPicker = false;
    },

    showDialogMsg(message){
      Dialog.alert({
        title: '查询结果',
        message: message,
        dangerouslyUseHTMLString: true
      });
    },
    //获取当前登录人名下注册登记的球杆
    selectProductByUser(){
      productByUser().then(res => {
        if (res.code === 200) {
          if(res.data){
            this.selectOptions = res.data.map(item => item.value);
          }
        } else {
          Dialog.alert({
            title: '提示',
            message: res.returnMsg,
            dangerouslyUseHTMLString: true
          }).then(() => {
            // on close
          });
        }
      }).catch(err => {
        Dialog.alert({
          title: '错误',
          message: '获取球杆编码失败，请稍后重试',
          dangerouslyUseHTMLString: true
        });
      })
    },
    // 真伪查询
    getProgress(){
      if(!this.number){ // 优化判空逻辑
        this.showDialogMsg('请输入球杆编码');
        return;
      }
      //先清除历史数据
      this.stepList = [];
      //球杆编号
      let keyWord = this.number;
      progress(keyWord).then(res => {

        if(res.code === 200){
          const data = res.data;

          if (data.code == 0) {
            this.showDialogMsg("您所输入的球杆编码不存在，请重新输入");
            return false;
          } else if(data.code == 2){

            this.showDialogMsg(data.returnMsg);
            return false;
          } else if(data.code == 3){
            //已登记未申请售后的
            this.showDialogMsg(data.returnMsg);
            return false;
          } else if(data.code == 4){
            this.showDialogMsg(data.returnMsg);
            return false;
          }else {
            this.stepList = res.data;
          }
        }
      });
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .van-icon-arrow-left {
  color: #0f0f0f !important;
}
::v-deep .van-nav-bar__text {
  color: #0f0f0f !important;
}
::v-deep .van-step__title.van-step__title--active h3,p{
  font-weight: normal;
}
::v-deep .van-step__title h3,p{
  font-weight: normal;
}
::v-deep .van-step__title p{
  padding-top: 5px;
}
.top-bar{
  background: linear-gradient(135deg, #D4AF37 0%, #B8860B 100%);
}
.container-item {
  padding: 0 16px;
  margin-bottom: 60px;
}
.search-card {
  margin: 16px 0;
  border-radius: 12px;
  height: 200px;
  /* 新增背景图样式 */
  background-image: url('~@/assets/img/h5/step_bk.png');
  background-size: cover; /* 背景图覆盖整个容器 */
  background-repeat: no-repeat; /* 不重复显示 */
  background-position: center center; /* 背景图居中显示 */
}
.search-input{
  margin-top: 160px;
  border-radius: 10px;
  border-bottom: none;
  background: linear-gradient(135deg, #D4AF37 0%, #B8860B 100%);
}

.search-btn {
  width: 100%;
  height: 48px;
  border-radius: 10px;
  background: linear-gradient(135deg, #D4AF37 0%, #B8860B 100%);
  color: #000;
  font-size: 16px;
  font-weight: bold;
  border: none;
  margin-bottom: 16px;
  margin-top: 32px;
}
.step-content{
  padding-bottom: 16px;
  border-radius: 10px;
}
</style>